import { UPDATE_META } from './actions';

export const updateMeta = ( payload ) => ( {
  type: UPDATE_META,
  payload
} );
